/* eslint-disable */

import axios from 'axios';

const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
  },
  mutations: {
  },
  actions: {
    sentAllUserEmailFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/account/send_all_user_email/', payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    sentMultipleUserEmailFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/account/send_multiple_mail/', payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    sentUnsubscribedMultipleUserEmailFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/account/send_unsubscribed_multiple_mail/', payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    selectedUsersMailSendAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/account/user-array-mail/', payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    selectedAllUsersMailSendAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/account/all-active-user-mail/', payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    selectedExelUsersMailSendAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/account/excel-user-list-mail/', payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
  }
}